@if (!video.filtered) {
  <div class="list-item hover dontgrow video learn-list-item" (click)="videoClicked(video)">
    <div class="list-item-container">
      <div class="image-container">
        <img [src]="video.image" class="item-image image-border" />
        @if (video.progress == 100) {
          <div class="done-indicator">
            <fa-icon icon="check"></fa-icon>
          </div>
        }
      </div>
      <div class="main-data">
        <h6>{{ video.title }}</h6>
        <span class="sub-data">
          @if (video.snippet || video.description) {
            <span class="description d-block" [class.short]="admin">{{ video.snippet || video.description }}</span>
          }
          <div class="video-metadata">
            <div class="video-metadata-item">
              <fa-icon icon="clock"></fa-icon>
              {{ helperService.hhmmss(video.duration, true) }}
            </div>
            <div class="video-metadata-item">
              <fa-icon icon="calendar"></fa-icon>
              {{ video.created | date }}
            </div>
            @if (video.start_date) {
              <div class="video-metadata-item">
                <fa-icon icon="sun"></fa-icon>
                Starts {{ video.start_date | date }}
              </div>
            }
            @if (video.end_date) {
              <div class="video-metadata-item">
                <fa-icon icon="moon"></fa-icon>
                Ends {{ video.end_date | date }}
              </div>
            }
            @if (video.level) {
              <div class="video-metadata-item">
                <fa-icon icon="graduation-cap"></fa-icon>
                {{ contentService.levels[video.level].toUpperCase() }}
              </div>
            }
            @if (admin || showAdd || showRemove) {
              <div class="video-metadata-item">
                <fa-icon icon="file"></fa-icon>
                ID {{ video.id }}
              </div>
              <div class="video-metadata-item">
                <fa-icon icon="file"></fa-icon>
                Platform ID {{ video.platform_id }}
              </div>
            }
          </div>
          @if (video.tags) {
            <div class="video-tags">
              @for (tag of video.tags; track tag) {
                <span class="pill sm trans">#{{ tag.title }}</span>
              }
            </div>
          }
          @if (admin || showAdd || showRemove) {
            <div class="admin-video-metadata">
              <span class="pill sm trans m-r-5">Platform: {{ video.platform.toUpperCase() }}</span>
              <span
                class="pill sm m-r-5"
                [class.green]="video.status == 'approved'"
                [class.orange]="video.status == 'pending'"
                [class.red]="video.status == 'ignored'"
                (click)="toggleApprove($event)"
                [ngbTooltip]="'Click to ' + (video.approved ? 'Unapprove' : 'Approve')"
              >
                {{ video.status.toUpperCase() }}
              </span>
              @if (video.subscription_only) {
                <span class="pill sm blue m-r-5">Subscribers Only</span>
              }
            </div>
          }
        </span>
      </div>
      @if (!hideActionButtons) {
        <div class="right-data-buttons">
          @if (video.subscription_only && !showAdd && !showRemove) {
            <img src="./assets/icons/plus-icon-blue.png" class="circle-icon-btn m-r-10" placement="left" [ngbTooltip]="'sphere.members_only' | translate" />
          }
          @if (!showAdd && !showRemove && showCopyLink) {
            <fa-icon icon="link" placement="left" (click)="copyLink(video, $event)" [ngbTooltip]="'Copy Link to This Video'" class="action circle-icon-btn m-r-10"></fa-icon>
          }
          @if (!admin && !showAdd && !showRemove) {
            <fa-icon
              (click)="pin($event)"
              [icon]="contentService.userLearnData.videos[video.id]?.saved ? 'minus' : 'plus'"
              placement="left"
              [ngbTooltip]="(contentService.userLearnData.videos[video.id]?.saved ? 'Remove From' : 'Add To') + ' My List'"
              class="action circle-icon-btn m-r-10"
            ></fa-icon>
          }
          @if (showAddToLesson) {
            <fa-icon icon="plus" placement="left" (click)="chooseLesson($event)" [ngbTooltip]="'Add To A Lesson'" class="action circle-icon-btn green m-r-10"></fa-icon>
          }
          @if (!showAdd && !showRemove && showChevron) {
            <fa-icon icon="chevron-right"></fa-icon>
          }
          @if (showAdd || showRemove) {
            <fa-icon icon="edit" placement="left" (click)="editVideo($event)" [ngbTooltip]="'Edit This Video'" class="action circle-icon-btn m-r-10"></fa-icon>
          }
          @if (showAdd) {
            <fa-icon icon="plus" placement="left" (click)="add($event)" [ngbTooltip]="'Add To This Lesson'" class="action circle-icon-btn green m-r-10"></fa-icon>
          }
          @if (showRemove) {
            <fa-icon icon="minus" placement="left" (click)="remove($event)" [ngbTooltip]="'Remove From This Lesson'" class="action circle-icon-btn red m-r-10"></fa-icon>
          }
        </div>
      }
    </div>
    @if (contentService.userLearnData.videos[video.id]?.progress) {
      <div class="progress-indicator" [ngStyle]="{ width: contentService.userLearnData.videos[video.id].progress + '%' }"></div>
    }
  </div>
}
